import React from 'react'
import { compose } from 'recompose'
import { useIntl } from 'gatsby-plugin-intl'
import PlaceAndDatesRangeBox from 'src/components/filters/PlaceAndDatesRangeBox'
import Select from 'src/components/filters/SelectBox'
import SelectRemote from 'src/components/filters/SelectRemoteBox'
import {
  SearchFilter,
  SelectWrapper
} from 'src/components/filters/components/atoms'
import { connectDictionaries } from 'src/ducks/connectors'
import {
  API_STATES,
  EXCHANGE_API_URL_PREFIXES,
  LOCATION_TYPES
} from 'src/ducks/consts'
import { canAddOffer } from 'src/features/offers/utils/exchangePermissions'
import { connectGeneral } from 'src/features/stocks/ducks/connectors'
import {
  EURO_OPTIONS,
  GENERAL_BOOLEAN_OPTIONS,
  REFERENCE_NUMBER_PREFIX,
  RESERVATION_STATUS_OPTIONS,
  VISIBILITY_OPTIONS
} from 'src/features/stocks/ducks/consts'
import PermissionsContext from 'src/utils/permissions'
import FiltersRow from './FiltersRow'

const GeneralCargoFilters = ({
  setFilter,
  setFilters,
  filters,
  dictionaries,
  fetchLocations,
  loadingDictionary,
  unloadingDictionary,
  companiesDictionary,
  fetchCompanies,
  activeFiltersNumber,
  clearFilters,
  createFilterTab,
  removeFilterTab,
  tabs,
  tabsData,
  activeTab,
  setActiveTab
}) => {
  const intl = useIntl()
  const permissions = React.useContext(PermissionsContext)

  return (
    <FiltersRow
      filters={filters}
      setFilters={setFilters}
      activeFiltersNumber={activeFiltersNumber}
      clearFilters={clearFilters}
      createFilterTab={createFilterTab}
      removeFilterTab={removeFilterTab}
      tabs={tabs}
      tabsData={tabsData}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      advancedFilters={
        <>
          <SelectRemote
            id='filters-general-company'
            name='company'
            label={intl.formatMessage({ id: 'offersFilters.company' })}
            value={filters.company}
            options={[]}
            onChange={setFilter}
            placeholder={intl.formatMessage({
              id: 'offersFilters.searchPlaceholder'
            })}
            searchHintText={intl.formatMessage(
              { id: 'forms.min_x_chars' },
              { value: 3 }
            )}
            dictionary={companiesDictionary}
            fetchCompanies={fetchCompanies}
          />
          <SelectWrapper>
            <Select
              height='440px'
              width='380px'
              id='filters-general-adr-classes'
              name='adrClass'
              label={intl.formatMessage({ id: 'offersFilters.adrClasses' })}
              value={filters.adrClass}
              options={dictionaries.adrClasses}
              onChange={setFilter}
              placeholder={intl.formatMessage({
                id: 'offersFilters.searchPlaceholder'
              })}
            />
          </SelectWrapper>
          <SelectWrapper>
            <Select
              removeSelectedOptions
              height='300px'
              width='230px'
              id='filters-general-euro'
              name='europeanEmissionStandard'
              label={intl.formatMessage({
                id: 'offersFilters.europeanEmissionStandard'
              })}
              value={filters.europeanEmissionStandard}
              options={EURO_OPTIONS.map(option => ({
                ...option,
                label: intl.formatMessage({ id: option.label })
              }))}
              onChange={setFilter}
              placeholder={intl.formatMessage({
                id: 'offersFilters.searchPlaceholder'
              })}
            />
          </SelectWrapper>
          <SelectWrapper>
            <Select
              height='350px'
              width='280px'
              id='filters-general-cargo-type'
              name='cargoType'
              label={intl.formatMessage({ id: 'offersFilters.cargoType' })}
              value={filters.cargoType}
              options={dictionaries.cargoTypes}
              onChange={setFilter}
              placeholder={intl.formatMessage({
                id: 'offersFilters.searchPlaceholder'
              })}
            />
          </SelectWrapper>
          <SelectWrapper>
            <Select
              removeSearchInput
              removeSelectedOptions
              height='250px'
              id='filters-general-status'
              name='status'
              label={intl.formatMessage({ id: 'offersFilters.status' })}
              value={filters.status}
              options={RESERVATION_STATUS_OPTIONS.map(option => ({
                ...option,
                label: intl.formatMessage({ id: option.label })
              }))}
              onChange={setFilter}
              placeholder={intl.formatMessage({
                id: 'offersFilters.searchPlaceholder'
              })}
              type='radio'
            />
          </SelectWrapper>
          <SelectWrapper>
            <Select
              removeSearchInput
              removeSelectedOptions
              height='250px'
              id='filters-general-sent'
              name='isSentRequired'
              label={intl.formatMessage({ id: 'offersFilters.sent' })}
              value={filters.isSentRequired}
              options={GENERAL_BOOLEAN_OPTIONS.map(option => ({
                ...option,
                label: intl.formatMessage({ id: option.label })
              }))}
              onChange={setFilter}
              placeholder={intl.formatMessage({
                id: 'offersFilters.searchPlaceholder'
              })}
              type='radio'
            />
          </SelectWrapper>
          <SelectWrapper>
            <Select
              removeSearchInput
              removeSelectedOptions
              height='250px'
              id='filters-general-line'
              name='isLine'
              label={intl.formatMessage({ id: 'offersFilters.line' })}
              value={filters.isLine}
              options={GENERAL_BOOLEAN_OPTIONS.map(option => ({
                ...option,
                label: intl.formatMessage({ id: option.label })
              }))}
              onChange={setFilter}
              placeholder={intl.formatMessage({
                id: 'offersFilters.searchPlaceholder'
              })}
              type='radio'
            />
          </SelectWrapper>
          {canAddOffer(
            EXCHANGE_API_URL_PREFIXES.GENERAL,
            permissions,
            'private'
          ) && (
            <SelectWrapper>
              <Select
                removeSearchInput
                removeSelectedOptions
                height='250px'
                id='filters-general-visibility'
                name='visibility'
                label={intl.formatMessage({ id: 'offersFilters.visibility' })}
                value={filters.visibility}
                options={VISIBILITY_OPTIONS.map(option => ({
                  ...option,
                  label: intl.formatMessage({ id: option.label })
                }))}
                onChange={setFilter}
                placeholder={intl.formatMessage({
                  id: 'offersFilters.searchPlaceholder'
                })}
                type='radio'
              />
            </SelectWrapper>
          )}
        </>
      }
    >
      <SelectWrapper>
        <SearchFilter
          name='referenceNumber'
          id='input-search-general'
          initValue={REFERENCE_NUMBER_PREFIX.GENERAL}
          filterValue={filters.referenceNumber}
          activeTab={activeTab}
          active={!!filters.referenceNumber}
          setFilter={setFilter}
          placeholder={intl.formatMessage({ id: 'common.offerNumber' })}
        />
      </SelectWrapper>
      <PlaceAndDatesRangeBox
        id='filters-general-loading'
        label={intl.formatMessage({ id: 'offersFilters.loading' })}
        onChange={setFilter}
        onChangeBulk={setFilters}
        locationName='loadingLocation'
        locationValue={filters.loadingLocation}
        locationCountryName='loadingLocationCountry'
        locationCountryValue={filters.loadingLocationCountry}
        dateFromName='loadingDateFrom'
        dateFromValue={filters.loadingDateFrom}
        dateFromLabel={intl.formatMessage({ id: 'offersFilters.loadingFrom' })}
        dateToName='loadingDateTo'
        dateToValue={filters.loadingDateTo}
        dateToLabel={intl.formatMessage({ id: 'offersFilters.loadingTo' })}
        locationTabName={intl.formatMessage({ id: 'offersFilters.place' })}
        datesTabName={intl.formatMessage({ id: 'offersFilters.date' })}
        placeholder={intl.formatMessage({
          id: 'offersFilters.locationPlaceholderPlace'
        })}
        locationTypes={LOCATION_TYPES.CITY}
        dictionary={loadingDictionary}
        isLoading={loadingDictionary.state === API_STATES.IN_PROGRESS}
        fetchLocations={fetchLocations}
        searchHintText={intl.formatMessage({
          id: 'offersFilters.searchHintText'
        })}
      />
      <PlaceAndDatesRangeBox
        id='filters-general-unloading'
        label={intl.formatMessage({ id: 'offersFilters.unloading' })}
        onChange={setFilter}
        onChangeBulk={setFilters}
        locationName='unloadingLocation'
        locationValue={filters.unloadingLocation}
        locationCountryName='unloadingLocationCountry'
        locationCountryValue={filters.unloadingLocationCountry}
        dateFromName='unloadingDateFrom'
        dateFromValue={filters.unloadingDateFrom}
        dateFromLabel={intl.formatMessage({
          id: 'offersFilters.unloadingFrom'
        })}
        dateToName='unloadingDateTo'
        dateToValue={filters.unloadingDateTo}
        dateToLabel={intl.formatMessage({
          id: 'offersFilters.unloadingTo'
        })}
        locationTabName={intl.formatMessage({ id: 'offersFilters.place' })}
        datesTabName={intl.formatMessage({ id: 'offersFilters.date' })}
        placeholder={intl.formatMessage({
          id: 'offersFilters.locationPlaceholderPlace'
        })}
        locationTypes={LOCATION_TYPES.CITY}
        dictionary={unloadingDictionary}
        isLoading={unloadingDictionary.state === API_STATES.IN_PROGRESS}
        fetchLocations={fetchLocations}
        searchHintText={intl.formatMessage({
          id: 'offersFilters.searchHintText'
        })}
      />
      <Select
        height='420px'
        id='filters-general-container'
        name='container'
        label={intl.formatMessage({ id: 'offersFilters.container' })}
        value={filters.container}
        options={dictionaries.containers}
        onChange={setFilter}
        placeholder={intl.formatMessage({
          id: 'offersFilters.searchPlaceholder'
        })}
      />
    </FiltersRow>
  )
}

export default compose(connectDictionaries, connectGeneral)(GeneralCargoFilters)
